var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4445 18H5.57656C5.42378 17.9996 5.27736 17.9387 5.16933 17.8307C5.06129 17.7226 5.00041 17.5762 5 17.4234V8H19.375C19.5408 8 19.6997 8.06585 19.8169 8.18306C19.9342 8.30027 20 8.45924 20 8.625V17.4445C20 17.5919 19.9415 17.7331 19.8373 17.8373C19.7331 17.9415 19.5919 18 19.4445 18Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8V6.5C5 6.36739 5.06146 6.24021 5.17085 6.14645C5.28025 6.05268 5.42862 6 5.58333 6H9.42531C9.57982 6.00006 9.72798 6.05266 9.83729 6.14625L12 8",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFolderIcon);
export default __webpack_public_path__ + "static/media/document-folder-icon.fe08ba472817fcb98d39eebb901792b0.svg";
export { ForwardRef as ReactComponent };